import { getFormattedMembershipDiscount } from 'features/paid-membership/ActivateMembershipPricing/utils';

/**
 * Renders the minus membership heading.
 * @param {Object} props
 * @param {string} props.as - The HTML tag to render the heading as.
 * @param {Object} props.availableCredits - The available credits for the membership.
 * @param {Object} props.availableTrialMembership - The available trial membership for the membership.
 * @param {string} props.className - The className to apply to the heading.
 * @param {Object} props.newMemberOffer - The new member offer for the membership.
 * @param {string} props.plusMembershipBranding - The plus membership branding.
 * @param {boolean} props.snapExclusive - Whether the membership is snap exclusive.
 */
function MinusMembershipHeading({
    as = 'h2',
    availableCredits,
    availableTrialMembership,
    className = '',
    newMemberOffer,
    plusMembershipBranding,
    snapExclusive,
}) {
    const Tag = as;

    const formattedDiscount = getFormattedMembershipDiscount({ newMemberOffer });

    let headingCopy = `Save big with ${plusMembershipBranding}`;

    if (!availableTrialMembership && formattedDiscount) {
        headingCopy = `Get ${formattedDiscount} off your membership and save big with ${plusMembershipBranding}`;
    }

    if (availableTrialMembership) {
        if (formattedDiscount) {
            headingCopy = `Start your free trial and get ${formattedDiscount} off your membership`;
        } else {
            headingCopy = `Start your free trial to save big with ${plusMembershipBranding}`;
        }
    }
    if (newMemberOffer?.type === 'discount' && snapExclusive) {
        headingCopy = `SNAP EBT exclusive: ${headingCopy}`;
    }

    if (availableCredits?.credits > 0) {
        headingCopy = `Get $${availableCredits?.credits} and save big with ${plusMembershipBranding}`;
    }

    return <Tag className={className}>{headingCopy}</Tag>;
}

export default MinusMembershipHeading;
